import { Dispatch, ThunkAction } from 'app/types/actions';
import { fetchHandler } from 'app/util/fetchHandler';
import { Util } from 'app/util/util';
import { REST_WEBHOOKS } from 'app/rest/constants';
import { getRestHeadersDelete } from 'app/rest/helpers/getRestHeadersHelper';
import { TBoardId } from '../../../../types/types';

export const deleteRest = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        return fetchHandler(
            Util.getApiUrl(REST_WEBHOOKS + boardId),
            getRestHeadersDelete(),
        );
    };
    return action;
};
